import logo from "../../../assets/logo-white.svg";

export default function SolveProblem() {
  return (
    <section id="solve_problem">
      <div className="container">
        <div className="row-essy items-center-essy ">
          <div className="col-essy-lg-6 col-essy-md-6">
            <div className="solve-wrapper">
              <h3>Why We’re Here</h3>
              <h2>We built Essy to solve a problem</h2>
              <p>
                Companies need skilled sales engineers, and sales engineers need
                roles that actually fit.
              </p>
              <p>
                No noise, no irrelevant job offers, just direct access to
                opportunities that make sense. We’re here to save everyone time,
                make hiring smarter, and keep things refreshingly simple.
              </p>
            </div>
          </div>
          <div className="col-essy-lg-6 col-essy-md-6">
            <div className="solve-col-right">
              <img src={logo} alt="logo" />
              <p>
                Essy is where companies and sales engineers find what they’ve
                been looking for—without the hassle.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
